// extracted by mini-css-extract-plugin
module.exports = {"delta2MaxTeaser":"teaser_delta2MaxTeaser__50Y_h"};